package nacholab.supplies

import io.ktor.client.HttpClient
import nacholab.supplies.domain.NetworkRespository
import nacholab.supplies.domain.PreferencesRepository
import nacholab.supplies.network.KtorClientBuilder
import nacholab.supplies.network.NetworkRepositoryImpl
import nacholab.supplies.storage.PreferencesRepositoryImpl
import org.koin.core.module.dsl.bind
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

val diAppModule = module {
    singleOf(::PreferencesRepositoryImpl) { bind<PreferencesRepository>() }
    singleOf(::NetworkRepositoryImpl) { bind<NetworkRespository>() }
    single<HttpClient> { KtorClientBuilder.buildKtorClient() }
}
